import React, { useEffect, useState } from "react";

import { Drawer, IconButton, Container } from "@material-ui/core";
import CommentBox from "./UI/molecules/CommentBox";
import CommentEntry from "./UI/molecules/CommentEntry";

import Badge from "@material-ui/core/Badge";
import MailIcon from "@material-ui/icons/Mail";

import { agentCommentsByDate } from "../graphql/queries.js";
import { createAgentComment } from "../graphql/mutations";
import { API, Amplify, Auth } from "aws-amplify";
import awsmobile from "../aws-exports";

Amplify.configure(awsmobile);

const TemporaryDrawer = () => {
  const FORM_KEY = "EDF:CurrentForm";
  const fromStorage = sessionStorage.getItem(FORM_KEY);

  const sessionQRCodeBase = JSON.parse(fromStorage).QRCodeBase;
  const sessionPartyID = JSON.parse(fromStorage).PartyID;

  const [agentComments, setAgentComments] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [comment, setComment] = useState("");

  useEffect(() => {
    fetchAgentComments();
  }, []);

  async function fetchAgentComments() {
    try {
      const response = await API.graphql({
        query: agentCommentsByDate,
        variables: { sortDirection: "ASC", QRCodeBase: sessionQRCodeBase },
      });
      setAgentComments(response.data.agentCommentsByDate.items);
    } catch (err) {
      console.log("error fetching agent comments");
    }
  }

  async function addAgentComments() {
    try {
      if (!comment) return;

      const roleValue = localStorage.getItem("location-select");

      let user = await Auth.currentAuthenticatedUser({
        bypassCache: false, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      });
      const { username } = user;

      await API.graphql({
        query: createAgentComment,
        variables: {
          input: {
            QRCodeBase: sessionQRCodeBase,
            PartyID: sessionPartyID,
            comment: comment,
            agentToTraveller: true,
            agent: username,
            location: roleValue,
          },
        },
      });

      fetchAgentComments();
      setComment("");
    } catch (err) {
      console.log("error creating agent comment", err);
    }
  }

  return (
    <React.Fragment>
      <Drawer
        open={openDrawer}
        variant="temporary"
        anchor="right"
        onClose={() => setOpenDrawer(false)}
      >
        <Container maxWidth="xs">
          <div
            style={{
              height: "75vh",
              overflow: "auto",
              position: "relative",
              top: "5%",
              width: "95%",
            }}
          >
            {agentComments.map((comment, index) => (
              <CommentBox
                key={comment.id}
                comment={comment.comment}
                createdAt={comment.createdAt}
                commentCreatedBy={comment.agent}
              />
            ))}
          </div>
          <div style={{ marginTop: "15%", marginBottom: "15%", width: "95%" }}>
            <CommentEntry
              textPlaceholderText="Enter inspection note ..."
              textValue={comment}
              textOnChange={(event) => setComment(event.target.value)}
              buttonOnClick={addAgentComments}
              buttonId="addCommentButton"
              buttonText="Add Inspection Note"
            />
          </div>
        </Container>
      </Drawer>

      {/* zIndex of Header is 1201. zindex of the mail icon is set to 1202
      so that the button overlaps the header */}
      <IconButton
        onClick={() => setOpenDrawer(!openDrawer)}
        disableRipple
        style={{ position: "fixed", top: "1%", right: "6%", zIndex: 1202 }}
      >
        <Badge badgeContent={agentComments.length} color="secondary">
          <MailIcon style={{ color: "white" }} />
        </Badge>
      </IconButton>
    </React.Fragment>
  );
};

export default TemporaryDrawer;
